module.exports = __webpack_public_path__ + "static/media/home-credit.bbb7a3a4.jpg";